// extracted by mini-css-extract-plugin
export default {"DeleteClientsDialog":"DeleteClientsDialog_DeleteClientsDialog__7W4kK"};